import React, { useContext, useEffect, useState } from 'react'
import ProductCommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import * as Yup from 'yup'
import ProfileComponent from '@/product/components/species/dynamic/Profile/ProfileComponent'
import ProfileNewComponent from '@/views/Dashboard/Profile/ProfileNewComponent'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { formatPhone, handleRedirectInternal } from '@/product/common/components'
import moment from 'moment'
import DashboardLayout from '../DashboardLayout'
import SEO from '@/utils/SEO'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const Myaccount = () => {
    const productCommonContext = useContext(ProductCommonContext)
    const authContext = useContext(AuthContext)
    const { allCountries, allStates } = productCommonContext
    const { user } = authContext
    const dynamicContext = useContext(DynamicContext)

    const { getAllDynamicArray, dynamicValue } = dynamicContext

    const [formikChangeValues, setFormikChangeValues] = useState({
        country: global.defaultCountry,
    })
    const [customValidation, setCustomValidation] = useState([])
    const [customValidationSeller, setCustomValidationSeller] = useState([])

    const [customInitialSeller, setCustomInitialSeller] = useState([])
    const [customInitialBuyer, setCustomInitialBuyer] = useState([])
    const [fieldValue, setFieldValue] = useState([])
    const [sellerValue, setSellerValue] = useState([])

    // Mapped over for individual registration fields

    const additionalFieldUpdate = (payload) => {
        setFormikChangeValues(payload)
    }

    useEffect(() => {
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    action: {
                        value: 3,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    forOrganization: {
                        value: 1,
                        type: 'in',
                        field: 'df.for_organization',
                    },
                    forSeller: {
                        value: 9,
                        type: 'findinsingle',
                        field: 'df.view_on',
                    },
                },
            },
            'forOrganization',
        )
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    active: {},
                    action: {
                        value: 3,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    forBuyer: {
                        value: 1,
                        type: 'in',
                        field: 'df.for_buyer',
                    },
                },
            },
            'forBuyer',
        )
    }, [])
    useEffect(() => {
        if (dynamicValue.from === 'forOrganization') {
            if (dynamicValue.records) {
                let dynamicValueAssign = []
                dynamicValue.records.map((item) => {
                    item.view_on
                        ? item.view_on.includes('2')
                            ? dynamicValueAssign.push(item)
                            : {}
                        : dynamicValueAssign.push(item)
                })
                const temp = dynamicValueAssign.filter((item) => {
                    return item.name != 'password' && item.name != 'confirm_password'
                })
                temp.map((ele) => {
                    if (ele.name === 'email') {
                        ele.disabled = true
                    }
                    if (ele?.type === 'misc') {
                        if (ele?.content && typeof ele?.content === 'string') {
                            ele.content = (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: ele?.content,
                                    }}
                                ></div>
                            )
                        }
                    }
                    if (ele.name === 'phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'additional_phone') {
                        ele.formatPhone = true
                    }
                    if (ele.name === 'license_expiry_date') {
                        ele.disablePast = true
                    }
                })
                setSellerValue(temp)
            }
        }
        if (dynamicValue.from === 'forBuyer') {
            if (dynamicValue.records) {
                let dynamicValueAssign = []
                dynamicValue.records.map((item) => {
                    item.view_on
                        ? item.view_on.includes('8')
                            ? dynamicValueAssign.push(item)
                            : {}
                        : dynamicValueAssign.push(item)
                })

                const temp = dynamicValueAssign.filter((item) => {
                    return item.name != 'password' && item.name != 'confirm_password'
                })
                temp.map((ele) => {
                    if (ele.name === 'email') {
                        ele.disabled = true
                    }
                    if (ele?.type === 'misc') {
                        if (ele?.label && typeof ele?.label === 'string') {
                            ele.content = (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: ele?.label,
                                    }}
                                ></div>
                            )
                        }
                    }
                    if (ele.name === 'license_expiry_date') {
                        ele.disablePast = true
                    }
                })
                setFieldValue(temp)
            }
        }
    }, [dynamicValue])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            admin: 0,
            phone: '',
            driver_license: '',
            license_expiry_date: '',
        }
        let customOrgInitial = {
            admin: 1,
            organization: 1,
            phone: '',
            driver_license: '',
            license_expiry_date: '',
        }
        customValidationTemp = {
            email: Yup.string()
                .email('Invalid Email Format')
                .max(250, 'Maximum 250 Characters')
                .required('Required'),
            resale_certificate: Yup.array().when('tax_number', {
                is: (end) => end && end.length > 0,
                then: Yup.array().required('Required!'),
            }),
            password: Yup.string()
                .matches(
                    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                    'Password must include uppercase and lowercase letters, a number, and a special character.',
                )
                .min(8, 'Minimum 8 Characters')
                .required('Required'),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Password does not match')
                .required('Required'),
            first_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            last_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            phone: Yup.string()
                .trim()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .required('Required'),
            additional_phone: Yup.string()
                .trim()
                .nullable()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .when('phone', {
                    is: (value) => value && value.length === 10,
                    then: Yup.string()
                        .nullable()
                        .notOneOf(
                            [Yup.ref('phone')],
                            'Mobile number and additional phone number should not be same',
                        ),
                }),
            phone_type: Yup.string().when('additional_phone', {
                is: (value) => value && value.length === 10,
                then: Yup.string().required('Required!'),
            }),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Positive Numbers only')
                .max(6, 'Maximum 6 characters')
                .required('Required')
                .nullable(),
            city: Yup.string()
                .trim()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .required('Required')
                .nullable(),
            driver_license: Yup.string(),
            license_expiry_date: Yup.date().when('driver_license', {
                is: (end) => end && end.length > 0,
                then: Yup.date()
                    .transform((__, value) => {
                        if (!value) {
                            return undefined
                        }
                        return value && typeof value === 'string'
                            ? new Date(
                                  moment(new Date(value.replace(/-/g, '/'))).subtract(1, 'minutes'),
                              )
                            : new Date(moment(value).subtract(1, 'minutes'))
                    })
                    .min(new Date(), 'Date must be greater than today')
                    .nullable()
                    .required('Required!'),
                otherwise: Yup.date().nullable(),
            }),
        }
        let sellerValidation = {
            ein_no: Yup.string()
                .min(5, 'Minimum 5 characters')
                .max(20, 'Maximum 20 characters')
                .required('Required'),
            email: Yup.string()
                .email('Invalid Email Format')
                .max(250, 'Maximum 250 Characters')
                .required('Required'),
            resale_certificate: Yup.array().when('tax_number', {
                is: (end) => end && end.length > 0,
                then: Yup.array().required('Required!'),
            }),
            password: Yup.string()
                .matches(
                    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/,
                    'Password must include uppercase and lowercase letters, a number, and a special character.',
                )
                .min(8, 'Minimum 8 Characters')
                .required('Required'),
            confirm_password: Yup.string()
                .oneOf([Yup.ref('password')], 'Password does not match')
                .required('Required'),
            first_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            last_name: Yup.string()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .min(2, 'Mininum 2 characters')
                .max(15, 'Maximum 15 characters')
                .required('Required!'),
            phone: Yup.string()
                .trim()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .required('Required'),
            additional_phone: Yup.string()
                .trim()
                .nullable()
                .min(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .max(10, (obj) => {
                    if (obj?.value?.length) {
                        return 'Phone must be 10 digits'
                    }
                })
                .when('phone', {
                    is: (value) => value && value.length === 10,
                    then: Yup.string()
                        .nullable()
                        .notOneOf(
                            [Yup.ref('phone')],
                            'Mobile number and additional phone number should not be same',
                        ),
                }),
            phone_type: Yup.string().when('additional_phone', {
                is: (value) => value && value.length === 10,
                then: Yup.string().required('Required!'),
            }),
            zip: Yup.string()
                .trim()
                .matches(/^[0-9]*$/g, 'Positive Numbers only')
                .max(6, 'Maximum 6 characters')
                .required('Required'),
            city: Yup.string()
                .trim()
                .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for this field ')
                .required('Required'),
            driver_license: Yup.string(),
            license_expiry_date: Yup.date().when('driver_license', {
                is: (end) => end && end.length > 0,
                then: Yup.date()
                    .transform((__, value) =>
                        value && typeof value === 'string'
                            ? new Date(
                                  moment(new Date(value.replace(/-/g, '/'))).subtract(1, 'minutes'),
                              )
                            : new Date(moment(value).subtract(1, 'minutes')),
                    )
                    .min(new Date(), 'Date must be greater than today')
                    .nullable()
                    .required('Required!'),
            }),
        }
        setCustomInitialSeller(customOrgInitial)
        setCustomInitialBuyer(customInitial)
        setCustomValidation(customValidationTemp)
        setCustomValidationSeller(sellerValidation)
    }, [])

    const history = useHistory()

    return (
        <DashboardLayout title={'My Account'}>
            <SEO title="My Account" url={window.location.href} />
            <div className="maTitle d-flex justify-content-between align-items-center w-100">
                <Button
                    onClick={() => {
                        handleRedirectInternal(history, 'my-account')
                    }}
                    className="moveBack"
                >
                    <span className="material-icons">keyboard_arrow_left</span>
                    {'Back to Account'}
                </Button>
            </div>
            <div className="payment-form-wrapper profile-wrapper pt-3 pb-3">
                <h1 className="title mb-3 text-center">PERSONAL INFORMATION</h1>
                <ProfileNewComponent />
                {/* {user && user.admin ? (
                <ProfileComponent
                    fieldValue={sellerValue}
                    customInitial={customInitialSeller}
                    customValidation={customValidationSeller}
                    formatPhone={true}
                    formatCustomDate={true}
                    phoneField={['phone', 'additional_phone']}
                    additionalfieldUpdate={additionalFieldUpdate}
                />
            ) : (
                <ProfileComponent
                    fieldValue={fieldValue}
                    customInitial={customInitialBuyer}
                    customValidation={customValidation}
                    formatPhone={true}
                    phoneField={['phone', 'additional_phone']}
                    formatCustomDate={true}
                    additionalfieldUpdate={additionalFieldUpdate}
                />
            )} */}
            </div>
        </DashboardLayout>
    )
}
export default Myaccount
